import { useState } from "react";
import  "./AromaLevels.css";


const AromaLevel = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.aromalevel===0?0:data.aromalevel);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="aromaLevelCard" name="aromalevel" className ="aromaLevel" onChange={onChangeValue}>
    <div class="aromaLevel-rating-container">

      <div class="aromaLevel-rating">
        <form class="aromaLevel-rating-form-1" >  
          <label for={`AL1F-${count}`}>
            <input type="radio"  name="aromalevel" class="aromaLevel1" id={`AL1F-${count}`}  value="6"  checked={'' + val === "6"} />
                <div className="aromacircle1"></div>
                <p>6</p>
           </label>

          <label for={`AL2F-${count}`}>
              <input type="radio" name="aromalevel" class="aromaLevel2" id={`AL2F-${count}`} value="6.25" checked={'' + val === "6.25"} />
                <div className="aromacircle2"></div>
               <p className="invisible">.5</p>
           </label>

          <label for={`AL3F-${count}`}>
              <input type="radio" name="aromalevel" class="aromaLevel3" id={`AL3F-${count}`} value="6.5" checked={'' + val === "6.5"} />
                <div className="aromacircle3"></div>
                <p className="invisible">.5</p>
            </label>

          <label for={`AL4F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel4" id={`AL4F-${count}`} value="6.75" checked={'' + val === "6.75"} />
               <div className="aromacircle4"></div>
               <p className="invisible">.5</p>

            </label>

          <label for={`AL5F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel5" id={`AL5F-${count}`} value="7" checked={'' + val === "7"} />
                <div className="aromacircle5"></div>
                <p>7</p>
             </label>
             {/* Didn't change it after this */}
             <label for={`AL6F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel6" id={`AL6F-${count}`} value="7.25" checked={'' + val === "7.25"} />
                <div className="aromacircle6"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`AL7F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel7" id={`AL7F-${count}`} value="7.5" checked={'' + val === "7.5"} />
                <div className="aromacircle7"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`AL8F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel8" id={`AL8F-${count}`} value="7.75" checked={'' + val === "7.75"} />
                <div className="aromacircle8"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`AL9F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel9" id={`AL9F-${count}`} value="8" checked={'' + val === "8"} />
                <div className="aromacircle9"></div>
                <p>8</p>

             </label>

             <label for={`AL10F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel10" id={`AL10F-${count}`} value="8.25" checked={'' + val === "8.25"} />
                <div className="aromacircle10"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`AL11F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel11" id={`AL11F-${count}`} value="8.5" checked={'' + val === "8.5"} />
                <div className="aromacircle11"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`AL12F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel12" id={`AL12F-${count}`} value="8.75" checked={'' + val === "8.75"} />
                <div className="aromacircle12"></div>
                <p className="invisible">.5</p>
             </label>


             <label for={`AL13F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel13" id={`AL13F-${count}`} value="9" checked={'' + val === "9"} />
                <div className="aromacircle13"></div>

                <p>9</p>
             </label>

             <label for={`AL14F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel14" id={`AL14F-${count}`} value="5.25" checked={'' + val === "9.25"} />
                <div className="aromacircle14"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`AL15F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel15" id={`AL15F-${count}`} value="9.5" checked={'' + val === "9.5"} />
                <div className="aromacircle15"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`AL16F-${count}`}>
             <input type="radio" name="aromalevel" className="aromaLevel16" id={`AL16F-${count}`} value="9.75" checked={'' + val === "9.75"} />
                <div className="aromacircle16"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`AL17F-${count}`}>
             <input type="radio" name="aromalevel" class="aromaLevel17" id={`AL17F-${count}`} value="10" checked={'' + val === "10"} />
                <div className="aromacircle17"></div>
                <p>10</p>
             </label>



        </form>
      </div>
    </div>
  </div>


    );
}

export default AromaLevel;